import { loadAsyncScript, debug, isTrackingEnabled } from "./helpers";
import { getGdlContext } from "./identity";

const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID;
const GTM_ENABLED = !!GTM_CONTAINER_ID;

function gtm(event, data = {}) {
  window.gtmDataLayer = window.gtmDataLayer || [];
  const fullEvent = { event, ...data };

  debug("gtm", JSON.stringify(fullEvent));
  window.gtmDataLayer.push(fullEvent);
}

export function ensureGtmDataLayer() {
  window.gtm = window.gtm || gtm;
  gtm("gtm.js", { "gtm.start": new Date().getTime() });
  if (GTM_ENABLED && isTrackingEnabled()) {
    loadAsyncScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}&l=gtmDataLayer`);
  }
}

export function trackPageView() {
  gtm("routeChange", { gdlContext: getGdlContext() });
}
